export default "__VITE_ASSET__CXifqk0c__"